import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  container: {
    mt: '80px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    minWidth: '368px',

    [theme.breakpoints.between('md', 'lg')]: {
      height: '700px',
    },

    [theme.breakpoints.down('md')]: {
      mt: '80px',
      backgroundImage: 'linear-gradient(to bottom, #FFFFFF, #919eab1f)',
      flexDirection: 'column',
      height: 'fit-content',
      alignItems: 'center',
      pr: '0px',
      justifyContent: 'center',
    },
  },

  textGrid: {
    // width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    pb: '40px',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      pl: '0px',
    },
  },

  textBox: {
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',

    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      alignItems: 'center',
    },
  },

  imagBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '60%',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      pl: '0px',
      pt: '20px',
    },
  },

  image: {
    position: 'relative',
    maxWidth: '584px',
    pr: '20px',

    [theme.breakpoints.between('md', 'lg')]: {
      height: '630px',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      mb: '80px',
      ml: '0px',
      pt: '0px',
      mt: '50px',
      pr: '0px',
      height: '700px',
    },

    [theme.breakpoints.down('sm')]: {
      mb: '80px',
      ml: '0px',
      pt: '0px',
      mt: '50px',
      width: '335px',
      height: '440px',
    },
  },

  greyText: {
    color: 'grey.500',
  },

  title: {
    mt: '20px',

    [theme.breakpoints.down('sm')]: {
      mt: '16px',
    },
  },

  text: {
    mt: '40px',
    color: 'grey.600',

    [theme.breakpoints.down('sm')]: {
      mt: '24px',
    },
  },

  button: {
    width: '129px',
    mt: '40px',
  },

  icon: {
    width: '56px',
    height: '56px',
    backgroundColor: '#258C17',
  },
});
